import React from "react";
import { ReactComponent as CrossIcon } from "../../assets/icons/black-cross-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  checkedFilterListing,
  deleteCheckFilterListing,
} from "../../Redux/Slices/ProductSlice";
import { deleteCheckFLMasterListing } from "../../Redux/Slices/FiltergetSlice";

const SelectedFilterDataCM = ({ setCurrentPage }) => {
  const { checkedFilter } = useSelector((e) => e.ProductSlice);
  const { checkedFilterCM } = useSelector((e) => e.FiltergetSlice);
  const dispatch = useDispatch();
  return (
    <div className="filter-select-items">
      <ul>
        {checkedFilterCM &&
          Object.entries(checkedFilterCM).map((e) => {
            return e[1].map((list, index) => {
              return (
                <li>
                  <span>
                    {" "}
                    {e[0] === "price"
                      ? `${list?.filterName[0]}-${list?.filterName[1]}`
                      : list?.filterName}{" "}
                  </span>
                  <CrossIcon
                    onClick={() => {
                      dispatch(
                        deleteCheckFLMasterListing({
                          uniqId: list?.uniqId,
                          name: e[0],
                        })
                      );
                      setCurrentPage(1);
                    }}
                  />
                </li>
              );
            });
          })}
      </ul>
    </div>
  );
};

export default SelectedFilterDataCM;
